export default function GovernanceSection() {
  return (
    <section className="py-28 px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Technical Personnel Statement */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-light-section border border-light-border rounded-full mb-6">
              <span className="text-industrial-steel text-xs font-medium tracking-[0.12em] uppercase">
                Technical Personnel
              </span>
            </div>
            <h2 className="font-serif text-dark-primary text-3xl leading-tight mb-6">
              Technical Personnel Background
            </h2>
            <p className="text-industrial-steel text-sm leading-[1.8] mb-8">
              Services are delivered by personnel with prior field experience in industrial manufacturing environments. Technical backgrounds include welding coordination, pressure equipment fabrication oversight, non-destructive testing supervision, and quality control operations in heavy fabrication facilities.
            </p>

            <div className="bg-light-section border border-light-border rounded-lg p-7 mb-8">
              <h3 className="text-dark-primary text-xs font-semibold uppercase tracking-wider mb-5">
                Personnel Experience Areas
              </h3>
              <ul className="space-y-3">
                {[
                  'Welding coordination and procedure qualification',
                  'Pressure vessel and heat exchanger fabrication',
                  'Structural steel fabrication and erection',
                  'Non-destructive testing oversight and interpretation',
                  'Protective coating application and inspection',
                  'Material traceability and documentation control',
                  'Manufacturing quality assurance systems',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3 text-industrial-steel text-sm">
                    <div className="w-1.5 h-1.5 rounded-full bg-industrial-steel mt-2 flex-shrink-0"></div>
                    <span className="leading-[1.7]">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-light-section border-l-2 border-industrial-steel/30 rounded-r-lg p-7">
              <h3 className="text-dark-primary text-xs font-semibold uppercase tracking-wider mb-4">
                Technical Competence
              </h3>
              <p className="text-industrial-steel text-sm leading-[1.8]">
                Personnel maintain familiarity with applicable codes, standards, and industry practices through ongoing involvement in fabrication oversight activities. Technical knowledge is applied within the scope of verification and surveillance services as defined by client requirements.
              </p>
            </div>
          </div>

          {/* Governance & Independence */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-light-section border border-light-border rounded-full mb-6">
              <span className="text-industrial-steel text-xs font-medium tracking-[0.12em] uppercase">
                Governance Framework
              </span>
            </div>
            <h2 className="font-serif text-dark-primary text-3xl leading-tight mb-6">
              Scope of Services and Authority
            </h2>
            <p className="text-industrial-steel text-sm leading-[1.8] mb-8">
              Arvakon provides independent observation and reporting of manufacturing activities against specified requirements. Services consist of verification, documentation, and technical surveillance during fabrication operations. Final acceptance authority, design approval, and regulatory compliance responsibility remain with the equipment purchaser, end user, project engineer, or designated certification body.
            </p>

            <div className="bg-light-section border border-light-border rounded-lg p-7 mb-8">
              <h3 className="text-dark-primary text-xs font-semibold uppercase tracking-wider mb-5">
                Service Scope
              </h3>
              <ul className="space-y-3">
                {[
                  'Independent verification and surveillance during manufacturing',
                  'Documentation review and traceability verification',
                  'Witness of testing and inspection activities',
                  'Reporting of observed conditions against specified requirements',
                  'Compilation of inspection records and technical documentation',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3 text-industrial-steel text-sm">
                    <div className="w-1.5 h-1.5 rounded-full bg-industrial-steel mt-2 flex-shrink-0"></div>
                    <span className="leading-[1.7]">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-light-section border-l-2 border-industrial-steel/30 rounded-r-lg p-7 mb-8">
              <h3 className="text-dark-primary text-xs font-semibold uppercase tracking-wider mb-4">
                Authority Clarification
              </h3>
              <p className="text-industrial-steel text-sm leading-[1.8] mb-5">
                Services are provided on a contractual basis to equipment purchasers or their designated representatives. Arvakon does not function as a certification body, notified body under PED 2014/68/EU, or authorized inspection agency under ASME Code.
              </p>
              <p className="text-industrial-muted text-sm leading-[1.8]">
                Design approval, regulatory authorization, and final acceptance decisions remain with the client or designated authority.
              </p>
            </div>

            <div className="bg-light-section border-l-2 border-industrial-steel/30 rounded-r-lg p-7">
              <h3 className="text-dark-primary text-xs font-semibold uppercase tracking-wider mb-4">
                Independence and Conflict of Interest
              </h3>
              <p className="text-industrial-steel text-sm leading-[1.8]">
                Arvakon maintains organizational and financial independence from entities subject to verification activities. Personnel assigned to verification activities maintain independence from commercial interests that could affect objectivity. Any potential conflict of interest is disclosed to clients prior to service commencement.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}